"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateRewardPrototype = validateRewardPrototype;
const validation_1 = require("../validation");
const definitions_1 = require("./definitions");
function validateRewardPrototype(reward, context) {
    const rewardDefinition = definitions_1.REWARDS[reward.type];
    if (!rewardDefinition) {
        throw new validation_1.ValidationError.MissingDefinition(`Missing definition for ${reward.type}. Update may be required.`);
    }
    // const validatorStr = `\n${rewardDefinition.configurationValidator.toString()}`;
    // console.debug(
    //   `Validating RewardPrototype`,
    //   reward,
    //   validatorStr.replaceAll("\n", "\n    ")
    // );
    return rewardDefinition.configurationValidator.validate(reward, context);
}
//# sourceMappingURL=RewardValidator.js.map